import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "image-content"
};
const _hoisted_2 = {
    class: "delete-icon"
};
const _hoisted_3 = [
    "onClick"
];
const _hoisted_4 = {
    class: "delete-icon"
};
import { ref, nextTick, watch, computed } from "vue";
import { useFormItem } from "element-plus";
import { debugWarn } from "element-plus/es/utils/error";
export default {
    __name: 'index',
    props: {
        modelValue: {
            type: [
                String,
                Array
            ],
            default: ""
        },
        max: {
            type: [
                String,
                Number
            ],
            default: 10
        },
        size: {
            type: [
                String,
                Number
            ],
            default: 60
        },
        width: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        height: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "update:modelValue",
        "success",
        "closed"
    ],
    setup (__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const imageSelectRef = ref(null);
        const visiable = ref(false);
        const { formItem } = useFormItem();
        const file = computed({
            get: ()=>props.modelValue,
            set: (val)=>emit('update:modelValue', val)
        });
        watch(()=>props.modelValue, (val)=>{
            formItem?.validate('change').catch((err)=>debugWarn(err));
        });
        const handleSuccess = (img)=>{
            if (Array.isArray(img) && img.length > 0) {
                let temp = props.max - file.value.length;
                if (temp <= 0) return;
                file.value = file.value.concat(img.slice(0, temp));
            } else {
                file.value = img;
            }
        };
        const show = ()=>{
            if (props.disabled) return false;
            visiable.value = true;
            nextTick(()=>{
                imageSelectRef.value.open();
            });
        };
        const deleteIcon = (index)=>{
            file.value.splice(index, 1);
            file.value = [
                ...file.value
            ];
        };
        const deleteImage = ()=>{
            file.value = "";
        };
        return (_ctx, _cache)=>{
            const _component_el_image = _resolveComponent("el-image");
            const _component_el_icon_delete = _resolveComponent("el-icon-delete");
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_icon_plus = _resolveComponent("el-icon-plus");
            const _component_scImageSelect = _resolveComponent("scImageSelect");
            return _openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    __props.multiple ? (_openBlock(), _createElementBlock(_Fragment, {
                        key: 0
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.value, (item, index)=>{
                            return _openBlock(), _createElementBlock("div", {
                                class: "imageBtn",
                                style: _normalizeStyle({
                                    width: `${__props.width || __props.size}px`,
                                    height: `${__props.height || __props.size}px`
                                }),
                                key: index
                            }, [
                                _createVNode(_component_el_image, {
                                    style: {
                                        "width": "100%",
                                        "height": "100%"
                                    },
                                    "initial-index": index,
                                    "preview-src-list": file.value,
                                    src: item,
                                    fit: "cover",
                                    "preview-teleported": ""
                                }, null, 8, [
                                    "initial-index",
                                    "preview-src-list",
                                    "src"
                                ]),
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("span", {
                                        class: "del",
                                        onClick: _withModifiers(($event)=>deleteIcon(index), [
                                            "stop"
                                        ])
                                    }, [
                                        _createVNode(_component_el_icon, null, {
                                            default: _withCtx(()=>[
                                                    _createVNode(_component_el_icon_delete)
                                                ]),
                                            _: 1
                                        })
                                    ], 8, _hoisted_3)
                                ])
                            ], 4);
                        }), 128)),
                        file.value.length < __props.max ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "uploadBtn",
                            style: _normalizeStyle({
                                width: `${__props.width || __props.size}px`,
                                height: `${__props.height || __props.size}px`
                            }),
                            onClick: show
                        }, [
                            _renderSlot(_ctx.$slots, "upload", {}, ()=>[
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_el_icon_plus)
                                            ]),
                                        _: 1
                                    })
                                ])
                        ], 4)) : _createCommentVNode("", true)
                    ], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                        key: 1
                    }, [
                        file.value ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "imageBtn",
                            style: _normalizeStyle({
                                margin: 0,
                                width: `${__props.width || __props.size}px`,
                                height: `${__props.height || __props.size}px`
                            })
                        }, [
                            _createVNode(_component_el_image, {
                                style: {
                                    "width": "100%",
                                    "height": "100%"
                                },
                                src: file.value,
                                "preview-src-list": [
                                    file.value
                                ],
                                fit: "cover",
                                "preview-teleported": ""
                            }, null, 8, [
                                "src",
                                "preview-src-list"
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                    class: "del",
                                    onClick: _withModifiers(deleteImage, [
                                        "stop"
                                    ])
                                }, [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_el_icon_delete)
                                            ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ], 4)) : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "uploadBtn",
                            style: _normalizeStyle({
                                margin: 0,
                                width: `${__props.width || __props.size}px`,
                                height: `${__props.height || __props.size}px`
                            }),
                            onClick: show
                        }, [
                            _renderSlot(_ctx.$slots, "upload", {}, ()=>[
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_el_icon_plus)
                                            ]),
                                        _: 1
                                    })
                                ])
                        ], 4))
                    ], 64))
                ]),
                visiable.value ? (_openBlock(), _createBlock(_component_scImageSelect, {
                    key: 0,
                    max: __props.max,
                    multiple: __props.multiple,
                    ref_key: "imageSelectRef",
                    ref: imageSelectRef,
                    onSuccess: handleSuccess,
                    onClosed: _cache[0] || (_cache[0] = ($event)=>visiable.value = false)
                }, null, 8, [
                    "max",
                    "multiple"
                ])) : _createCommentVNode("", true)
            ], 64);
        };
    }
};
